export default __webpack_public_path__ + "static/media/SEN-POW.1c9bbe30.png";